import React from 'react'
import UserHeader from './UserHeader'
import UserFooter from './UserFooter'

function Index7() {
  return (
    <div>
        <UserHeader/>
        <main className="main">
  <div className="container-fluid">
    <div className="row">
      <div className="col-lg-6">
        <div className="banner banner-big banner-overlay">
          <a href="#">
            <img src="asset/images/demos/demo-7/banners/banner-1.jpg" alt="Banner" />
          </a>
          <div className="banner-content banner-content-center">
            <h3 className="banner-subtitle text-white"><a href="#">New Collection</a></h3>{/* End .banner-subtitle */}
            <h2 className="banner-title text-white"><a href="#">Shop Women's</a></h2>{/* End .banner-title */}
            <a href="#" className="btn underline"><span>Discover Now</span></a>
          </div>{/* End .banner-content */}
        </div>{/* End .banner */}
      </div>{/* End .col-lg-6 */}
      <div className="col-lg-6">
        <div className="banner banner-big banner-overlay">
          <a href="#">
            <img src="asset/images/demos/demo-7/banners/banner-2.jpg" alt="Banner" />
          </a>
          <div className="banner-content banner-content-center">
            <h3 className="banner-subtitle text-white"><a href="#">New Collection</a></h3>{/* End .banner-subtitle */}
            <h2 className="banner-title text-white"><a href="#">Shop Men's</a></h2>{/* End .banner-title */}
            <a href="#" className="btn underline"><span>Discover Now</span></a>
          </div>{/* End .banner-content */}
        </div>{/* End .banner */}
      </div>{/* End .col-lg-6 */}
    </div>{/* End .row */}
    <div className="row justify-content-center">
      <div className="col-md-6 col-lg-4">
        <div className="banner banner-overlay text-white">
          <a href="#">
            <img src="asset/images/demos/demo-7/banners/banner-3.jpg" alt="Banner" />
          </a>
          <div className="banner-content banner-content-right">
            <h4 className="banner-subtitle"><a href="#">Flip Flop</a></h4>{/* End .banner-subtitle */}
            <h3 className="banner-title"><a href="#">Summer<br />sale -70% off</a></h3>{/* End .banner-title */}
            <a href="#" className="btn underline btn-outline-white-3 banner-link">Shop Now</a>
          </div>{/* End .banner-content */}
        </div>{/* End .banner */}
      </div>{/* End .col-lg-4 */}
      <div className="col-md-6 col-lg-4">
        <div className="banner banner-overlay color-grey">
          <a href="#">
            <img src="asset/images/demos/demo-7/banners/banner-4.jpg" alt="Banner" />
          </a>
          <div className="banner-content">
            <h4 className="banner-subtitle"><a href="#">Accessories</a></h4>{/* End .banner-subtitle */}
            <h3 className="banner-title"><a href="#">2019 Winter<br />up to 50% off</a></h3>{/* End .banner-title */}
            <a href="#" className="btn underline banner-link">Shop Now</a>
          </div>{/* End .banner-content */}
        </div>{/* End .banner */}
      </div>{/* End .col-lg-4 */}
      <div className="col-md-6 col-lg-4">
        <div className="banner banner-overlay text-white">
          <a href="#">
            <img src="asset/images/demos/demo-7/banners/banner-5.jpg" alt="Banner" />
          </a>
          <div className="banner-content banner-content-right mr">
            <h4 className="banner-subtitle"><a href="#">New in</a></h4>{/* End .banner-subtitle */}
            <h3 className="banner-title"><a href="#">Women’s<br />sportswear</a></h3>{/* End .banner-title */}
            <a href="#" className="btn underline btn-outline-white-3 banner-link">Shop Now</a>
          </div>{/* End .banner-content */}
        </div>{/* End .banner */}
      </div>{/* End .col-lg-4 */}
    </div>{/* End .row */}
  </div>{/* End .container-fluid */}
  <div className="icon-boxes-container bg-transparent">
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-lg-8 col-12 icon-boxes">
          <div className="col-sm-6 col-lg-4">
            <div className="icon-box icon-box-side">
              <span className="icon-box-icon">
                <i className="icon-truck" />
              </span>
              <div className="icon-box-content">
                <h3 className="icon-box-title">Payment &amp; Delivery</h3>{/* End .icon-box-title */}
                <p>Free shipping for orders over $50</p>
              </div>{/* End .icon-box-content */}
            </div>{/* End .icon-box */}
          </div>{/* End .col-sm-6 col-lg-4 */}
          <div className="col-sm-6 col-lg-4">
            <div className="icon-box icon-box-side">
              <span className="icon-box-icon">
                <i className="icon-rotate-left" />
              </span>
              <div className="icon-box-content">
                <h3 className="icon-box-title">Return &amp; Refund</h3>{/* End .icon-box-title */}
                <p>Free 100% money back guarantee</p>
              </div>{/* End .icon-box-content */}
            </div>{/* End .icon-box */}
          </div>{/* End .col-sm-6 col-lg-4 */}
          <div className="col-sm-6 col-lg-4">
            <div className="icon-box icon-box-side">
              <span className="icon-box-icon">
                <i className="icon-headphones" />
              </span>
              <div className="icon-box-content">
                <h3 className="icon-box-title">Quality Support</h3>{/* End .icon-box-title */}
                <p>Alway online feedback 24/7</p>
              </div>{/* End .icon-box-content */}
            </div>{/* End .icon-box */}
          </div>{/* End .col-sm-6 col-lg-4 */}
        </div>
      </div>{/* End .row */}
    </div>{/* End .container */}
  </div>{/* End .icon-boxes-container */}
  <div className="bg-light-2 pt-6 pb-6 featured">
    <div className="container-fluid">
      <div className="heading heading-center mb-3">
        <h2 className="title">FEATURED PRODUCTS</h2>{/* End .title */}
        <ul className="nav nav-pills justify-content-center" role="tablist">
          <li className="nav-item">
            <a className="nav-link active" id="featured-women-link" data-toggle="tab" href="#featured-women-tab" role="tab" aria-controls="featured-women-tab" aria-selected="true">Womens Clothing</a>
          </li>
          <li className="nav-item">
            <a className="nav-link" id="featured-men-link" data-toggle="tab" href="#featured-men-tab" role="tab" aria-controls="featured-men-tab" aria-selected="false">Mens Clothing</a>
          </li>
        </ul>
      </div>{/* End .heading */}
      <div className="tab-content tab-content-carousel">
        <div className="tab-pane p-0 fade show active" id="featured-women-tab" role="tabpanel" aria-labelledby="featured-women-link">
          <div className="owl-carousel owl-simple carousel-equal-height carousel-with-shadow" data-toggle="owl" data-owl-options="{
                  &quot;nav&quot;: false, 
                  &quot;dots&quot;: true,
                  &quot;margin&quot;: 20,
                  &quot;loop&quot;: false,
                  &quot;responsive&quot;: {
                      &quot;0&quot;: {
                          &quot;items&quot;:2
                      },
                      &quot;480&quot;: {
                          &quot;items&quot;:2
                      },
                      &quot;768&quot;: {
                          &quot;items&quot;:3
                      },
                      &quot;992&quot;: {
                          &quot;items&quot;:4
                      },
                      &quot;1200&quot;: {
                          &quot;items&quot;:5,
                          &quot;nav&quot;: true
                      }
                  }
              }">
            <div className="product product-7 text-center">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-7/products/product-1-1.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-7/products/product-1-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                </div>{/* End .product-action-vertical */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <h3 className="product-title"><a href="product.html">Backpack</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $60.00
                </div>{/* End .product-price */}
                <div className="ratings-container">
                  <div className="ratings">
                    <div className="ratings-val" style={{width: '20%'}} />{/* End .ratings-val */}
                  </div>{/* End .ratings */}
                  <span className="ratings-text">( 2 Reviews )</span>
                </div>{/* End .rating-container */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
            <div className="product product-7 text-center">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-7/products/product-2-1.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-7/products/product-2-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                </div>{/* End .product-action-vertical */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <h3 className="product-title"><a href="product.html">Biker jacket</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $120.99
                </div>{/* End .product-price */}
                <div className="ratings-container">
                  <div className="ratings">
                    <div className="ratings-val" style={{width: '20%'}} />{/* End .ratings-val */}
                  </div>{/* End .ratings */}
                  <span className="ratings-text">( 2 Reviews )</span>
                </div>{/* End .rating-container */}
                <div className="product-nav product-nav-dots">
                  <a href="#" className="active" style={{background: '#d79442'}}><span className="sr-only">Color name</span></a>
                  <a href="#" style={{background: '#cc3333'}}><span className="sr-only">Color name</span></a>
                </div>{/* End .product-nav */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
            <div className="product product-7 text-center">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-7/products/product-3-1.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-7/products/product-3-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                </div>{/* End .product-action-vertical */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <h3 className="product-title"><a href="product.html">Sandals</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $70.00
                </div>{/* End .product-price */}
                <div className="ratings-container">
                  <div className="ratings">
                    <div className="ratings-val" style={{width: '60%'}} />{/* End .ratings-val */}
                  </div>{/* End .ratings */}
                  <span className="ratings-text">( 4 Reviews )</span>
                </div>{/* End .rating-container */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
            <div className="product product-7 text-center">
              <figure className="product-media">
                <span className="product-label label-circle label-sale">Sale</span>
                <a href="product.html">
                  <img src="asset/images/demos/demo-7/products/product-4-1.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-7/products/product-4-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                </div>{/* End .product-action-vertical */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
                <div className="deal-countdown offer-countdown" data-until="+11d" />{/* End .deal-countdown */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <h3 className="product-title"><a href="product.html">Super Skinny High Jeggings</a></h3>{/* End .product-title */}
                <div className="product-price">
                  <span className="new-price">$190.00</span>
                  <span className="old-price">$310.00</span>
                </div>{/* End .product-price */}
                <div className="ratings-container">
                  <div className="ratings">
                    <div className="ratings-val" style={{width: '40%'}} />{/* End .ratings-val */}
                  </div>{/* End .ratings */}
                  <span className="ratings-text">( 4 Reviews )</span>
                </div>{/* End .rating-container */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
            <div className="product product-7 text-center">
              <figure className="product-media">
                <span className="product-label label-circle label-top">Top</span>
                <a href="product.html">
                  <img src="asset/images/demos/demo-7/products/product-5-1.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-7/products/product-5-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                </div>{/* End .product-action-vertical */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <h3 className="product-title"><a href="product.html">Short wrap dress</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $80.00
                </div>{/* End .product-price */}
                <div className="ratings-container">
                  <div className="ratings">
                    <div className="ratings-val" style={{width: '100%'}} />{/* End .ratings-val */}
                  </div>{/* End .ratings */}
                  <span className="ratings-text">( 6 Reviews )</span>
                </div>{/* End .rating-container */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
            <div className="product product-7 text-center">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-7/products/product-1-1.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-7/products/product-1-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                </div>{/* End .product-action-vertical */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <h3 className="product-title"><a href="product.html">Backpack</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $60.00
                </div>{/* End .product-price */}
                <div className="ratings-container">
                  <div className="ratings">
                    <div className="ratings-val" style={{width: '20%'}} />{/* End .ratings-val */}
                  </div>{/* End .ratings */}
                  <span className="ratings-text">( 2 Reviews )</span>
                </div>{/* End .rating-container */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .owl-carousel */}
        </div>{/* .End .tab-pane */}
        <div className="tab-pane p-0 fade" id="featured-men-tab" role="tabpanel" aria-labelledby="featured-men-link">
          <div className="owl-carousel owl-simple carousel-equal-height carousel-with-shadow" data-toggle="owl" data-owl-options="{
                  &quot;nav&quot;: false, 
                  &quot;dots&quot;: true,
                  &quot;margin&quot;: 20,
                  &quot;loop&quot;: false,
                  &quot;responsive&quot;: {
                      &quot;0&quot;: {
                          &quot;items&quot;:1
                      },
                      &quot;480&quot;: {
                          &quot;items&quot;:2
                      },
                      &quot;768&quot;: {
                          &quot;items&quot;:3
                      },
                      &quot;992&quot;: {
                          &quot;items&quot;:4
                      },
                      &quot;1200&quot;: {
                          &quot;items&quot;:5,
                          &quot;nav&quot;: true
                      }
                  }
              }">
            <div className="product product-7 text-center">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-7/products/product-2-1.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-7/products/product-2-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                </div>{/* End .product-action-vertical */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <h3 className="product-title"><a href="product.html">Biker jacket</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $120.99
                </div>{/* End .product-price */}
                <div className="ratings-container">
                  <div className="ratings">
                    <div className="ratings-val" style={{width: '20%'}} />{/* End .ratings-val */}
                  </div>{/* End .ratings */}
                  <span className="ratings-text">( 2 Reviews )</span>
                </div>{/* End .rating-container */}
                <div className="product-nav product-nav-dots">
                  <a href="#" className="active" style={{background: '#d79442'}}><span className="sr-only">Color name</span></a>
                  <a href="#" style={{background: '#cc3333'}}><span className="sr-only">Color name</span></a>
                </div>{/* End .product-nav */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
            <div className="product product-7 text-center">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-7/products/product-3-1.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-7/products/product-3-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                </div>{/* End .product-action-vertical */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <h3 className="product-title"><a href="product.html">Sandals</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $70.00
                </div>{/* End .product-price */}
                <div className="ratings-container">
                  <div className="ratings">
                    <div className="ratings-val" style={{width: '60%'}} />{/* End .ratings-val */}
                  </div>{/* End .ratings */}
                  <span className="ratings-text">( 4 Reviews )</span>
                </div>{/* End .rating-container */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
            <div className="product product-7 text-center">
              <figure className="product-media">
                <span className="product-label label-circle label-sale">Sale</span>
                <a href="product.html">
                  <img src="asset/images/demos/demo-7/products/product-4-1.jpg" alt="Product image" className="product-image" />
                  <img src="asset/images/demos/demo-7/products/product-4-2.jpg" alt="Product image" className="product-image-hover" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                  <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                </div>{/* End .product-action-vertical */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
                <div className="deal-countdown offer-countdown" data-until="+11d" />{/* End .deal-countdown */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <h3 className="product-title"><a href="product.html">Super Skinny High Jeggings</a></h3>{/* End .product-title */}
                <div className="product-price">
                  <span className="new-price">$190.00</span>
                  <span className="old-price">$310.00</span>
                </div>{/* End .product-price */}
                <div className="ratings-container">
                  <div className="ratings">
                    <div className="ratings-val" style={{width: '40%'}} />{/* End .ratings-val */}
                  </div>{/* End .ratings */}
                  <span className="ratings-text">( 4 Reviews )</span>
                </div>{/* End .rating-container */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .owl-carousel */}
        </div>{/* .End .tab-pane */}
      </div>{/* End .tab-content */}
    </div>{/* End .container-fluid */}
  </div>{/* End .bg-light-2 pt-4 pb-4 */}
  <div className="mb-6" />{/* End .mb-6 */}
  <div className="container-fluid">
    <div className="heading heading-center mb-3">
      <h2 className="title">NEW ARRIVALS</h2>{/* End .title */}
      <ul className="nav nav-pills justify-content-center" role="tablist">
        <li className="nav-item">
          <a className="nav-link active" id="new-women-link" data-toggle="tab" href="#new-women-tab" role="tab" aria-controls="new-women-tab" aria-selected="true">Womens Clothing</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" id="new-men-link" data-toggle="tab" href="#new-men-tab" role="tab" aria-controls="new-men-tab" aria-selected="false">Mens Clothing</a>
        </li>
      </ul>
    </div>{/* End .heading */}
    <div className="tab-content">
      <div className="tab-pane p-0 fade show active" id="new-women-tab" role="tabpanel" aria-labelledby="new-women-link">
        <div className="products">
          <div className="row justify-content-center">
            <div className="col-6 col-md-4 col-lg-3 col-xl-5col">
              <div className="product product-7 text-center">
                <figure className="product-media">
                  <span className="product-label label-circle label-sale">Sale</span>
                  <a href="product.html">
                    <img src="asset/images/demos/demo-7/products/product-6-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-7/products/product-6-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  </div>{/* End .product-action-vertical */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Tie-detail top</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    <span className="new-price">$50.00</span>
                    <span className="old-price">$84.00</span>
                  </div>{/* End .product-price */}
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '40%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <span className="ratings-text">( 4 Reviews )</span>
                  </div>{/* End .rating-container */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
            <div className="col-6 col-md-4 col-lg-3 col-xl-5col">
              <div className="product product-7 text-center">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-7/products/product-7-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-7/products/product-7-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  </div>{/* End .product-action-vertical */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Dress with a belt</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $120.99
                  </div>{/* End .product-price */}
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '20%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <span className="ratings-text">( 2 Reviews )</span>
                  </div>{/* End .rating-container */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
            <div className="col-6 col-md-4 col-lg-3 col-xl-5col">
              <div className="product product-7 text-center">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-7/products/product-8-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-7/products/product-8-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  </div>{/* End .product-action-vertical */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Linen-blend paper bag trousers</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $60.00
                  </div>{/* End .product-price */}
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '20%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <span className="ratings-text">( 2 Reviews )</span>
                  </div>{/* End .rating-container */}
                  <div className="product-nav product-nav-dots">
                    <a href="#" className="active" style={{background: '#d5ad81'}}><span className="sr-only">Color name</span></a>
                    <a href="#" style={{background: '#333333'}}><span className="sr-only">Color name</span></a>
                  </div>{/* End .product-nav */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
            <div className="col-6 col-md-4 col-lg-3 col-xl-5col">
              <div className="product product-7 text-center">
                <figure className="product-media">
                  <span className="product-label label-circle label-top">Top</span>
                  <a href="product.html">
                    <img src="asset/images/demos/demo-7/products/product-9-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-7/products/product-9-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  </div>{/* End .product-action-vertical */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Paper straw shopper</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $80.95
                  </div>{/* End .product-price */}
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '100%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <span className="ratings-text">( 6 Reviews )</span>
                  </div>{/* End .rating-container */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
            <div className="col-6 col-md-4 col-lg-3 col-xl-5col">
              <div className="product product-7 text-center">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-7/products/product-10-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-7/products/product-10-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  </div>{/* End .product-action-vertical */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Trainers</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $56.00
                  </div>{/* End .product-price */}
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '20%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <span className="ratings-text">( 2 Reviews )</span>
                  </div>{/* End .rating-container */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
            <div className="col-6 col-md-4 col-lg-3 col-xl-5col">
              <div className="product product-7 text-center">
                <figure className="product-media">
                  <span className="product-label label-circle label-sale">Sale</span>
                  <a href="product.html">
                    <img src="asset/images/demos/demo-7/products/product-11-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-7/products/product-11-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  </div>{/* End .product-action-vertical */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Hooded top </a></h3>{/* End .product-title */}
                  <div className="product-price">
                    <span className="new-price">$50.00</span>
                    <span className="old-price">$84.00</span>
                  </div>{/* End .product-price */}
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '40%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <span className="ratings-text">( 4 Reviews )</span>
                  </div>{/* End .rating-container */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
            <div className="col-6 col-md-4 col-lg-3 col-xl-5col">
              <div className="product product-7 text-center">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-7/products/product-12-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-7/products/product-12-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  </div>{/* End .product-action-vertical */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Vest dress</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $89.99
                  </div>{/* End .product-price */}
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '80%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <span className="ratings-text">( 2 Reviews )</span>
                  </div>{/* End .rating-container */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
            <div className="col-6 col-md-4 col-lg-3 col-xl-5col">
              <div className="product product-7 text-center">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-7/products/product-13-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-7/products/product-13-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  </div>{/* End .product-action-vertical */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Long-sleeved blouse</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $84.00
                  </div>{/* End .product-price */}
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '60%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <span className="ratings-text">( 3 Reviews )</span>
                  </div>{/* End .rating-container */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
            <div className="col-6 col-md-4 col-lg-3 col-xl-5col">
              <div className="product product-7 text-center">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-7/products/product-14-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-7/products/product-14-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  </div>{/* End .product-action-vertical */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Denim jacket</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $80.95
                  </div>{/* End .product-price */}
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '20%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <span className="ratings-text">( 2 Reviews )</span>
                  </div>{/* End .rating-container */}
                  <div className="product-nav product-nav-dots">
                    <a href="#" className="active" style={{background: '#7ba1c9'}}><span className="sr-only">Color name</span></a>
                    <a href="#" style={{background: '#333333'}}><span className="sr-only">Color name</span></a>
                    <a href="#" style={{background: '#feb143'}}><span className="sr-only">Color name</span></a>
                    <a href="#" style={{background: '#f0c7b7'}}><span className="sr-only">Color name</span></a>
                  </div>{/* End .product-nav */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
            <div className="col-6 col-md-4 col-lg-3 col-xl-5col">
              <div className="product product-7 text-center">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-7/products/product-15-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-7/products/product-15-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  </div>{/* End .product-action-vertical */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Sunglasses</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $56.00
                  </div>{/* End .product-price */}
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '20%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <span className="ratings-text">( 2 Reviews )</span>
                  </div>{/* End .rating-container */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
          </div>{/* End .row */}
        </div>{/* End .products */}
      </div>{/* .End .tab-pane */}
      <div className="tab-pane p-0 fade" id="new-men-tab" role="tabpanel" aria-labelledby="new-men-link">
        <div className="products">
          <div className="row justify-content-center">
            <div className="col-6 col-md-4 col-lg-3 col-xl-5col">
              <div className="product product-7 text-center">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-7/products/product-8-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-7/products/product-8-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  </div>{/* End .product-action-vertical */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Linen-blend paper bag trousers</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $60.00
                  </div>{/* End .product-price */}
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '20%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <span className="ratings-text">( 2 Reviews )</span>
                  </div>{/* End .rating-container */}
                  <div className="product-nav product-nav-dots">
                    <a href="#" className="active" style={{background: '#d5ad81'}}><span className="sr-only">Color name</span></a>
                    <a href="#" style={{background: '#333333'}}><span className="sr-only">Color name</span></a>
                  </div>{/* End .product-nav */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
            <div className="col-6 col-md-4 col-lg-3 col-xl-5col">
              <div className="product product-7 text-center">
                <figure className="product-media">
                  <span className="product-label label-circle label-top">Top</span>
                  <a href="product.html">
                    <img src="asset/images/demos/demo-7/products/product-9-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-7/products/product-9-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  </div>{/* End .product-action-vertical */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Paper straw shopper</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $80.95
                  </div>{/* End .product-price */}
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '100%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <span className="ratings-text">( 6 Reviews )</span>
                  </div>{/* End .rating-container */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
            <div className="col-6 col-md-4 col-lg-3 col-xl-5col">
              <div className="product product-7 text-center">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-7/products/product-10-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-7/products/product-10-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  </div>{/* End .product-action-vertical */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Trainers</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $56.00
                  </div>{/* End .product-price */}
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '20%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <span className="ratings-text">( 2 Reviews )</span>
                  </div>{/* End .rating-container */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
            <div className="col-6 col-md-4 col-lg-3 col-xl-5col">
              <div className="product product-7 text-center">
                <figure className="product-media">
                  <span className="product-label label-circle label-sale">Sale</span>
                  <a href="product.html">
                    <img src="asset/images/demos/demo-7/products/product-11-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-7/products/product-11-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  </div>{/* End .product-action-vertical */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Hooded top </a></h3>{/* End .product-title */}
                  <div className="product-price">
                    <span className="new-price">$50.00</span>
                    <span className="old-price">$84.00</span>
                  </div>{/* End .product-price */}
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '40%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <span className="ratings-text">( 4 Reviews )</span>
                  </div>{/* End .rating-container */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
            <div className="col-6 col-md-4 col-lg-3 col-xl-5col">
              <div className="product product-7 text-center">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-7/products/product-12-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-7/products/product-12-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  </div>{/* End .product-action-vertical */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Vest dress</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $89.99
                  </div>{/* End .product-price */}
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '80%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <span className="ratings-text">( 2 Reviews )</span>
                  </div>{/* End .rating-container */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
            <div className="col-6 col-md-4 col-lg-3 col-xl-5col">
              <div className="product product-7 text-center">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-7/products/product-13-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-7/products/product-13-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
                    <a href="popup/quickView.html" className="btn-product-icon btn-quickview" title="Quick view"><span>Quick view</span></a>
                  </div>{/* End .product-action-vertical */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  </div>{/* End .product-action */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Long-sleeved blouse</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $84.00
                  </div>{/* End .product-price */}
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '60%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <span className="ratings-text">( 3 Reviews )</span>
                  </div>{/* End .rating-container */}
                </div>{/* End .product-body */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
          </div>{/* End .row */}
        </div>{/* End .products */}
      </div>{/* .End .tab-pane */}
    </div>{/* End .tab-content */}
    <div className="more-container text-center mt-2">
      <a href="#" className="btn btn-outline-dark-3 btn-more"><span>Load more</span><i className="icon-long-arrow-right" /></a>
    </div>{/* End .more-container */}
    <hr className="mt-0 mb-6" />
    <div className="blog-posts mb-4">
      <h2 className="title text-center mb-3">From Our Blog</h2>{/* End .title text-center */}
      <div className="owl-carousel owl-simple mb-2" data-toggle="owl" data-owl-options="{
          &quot;nav&quot;: false, 
          &quot;dots&quot;: true,
          &quot;items&quot;: 3,
          &quot;margin&quot;: 20,
          &quot;loop&quot;: false,
          &quot;responsive&quot;: {
              &quot;0&quot;: {
                  &quot;items&quot;:1
              },
              &quot;520&quot;: {
                  &quot;items&quot;:2
              },
              &quot;768&quot;: {
                  &quot;items&quot;:3
              },
              &quot;992&quot;: {
                  &quot;items&quot;:4
              }
          }
      }">
        <article className="entry">
          <figure className="entry-media">
            <a href="single.html">
              <img src="asset/images/demos/demo-7/blog/post-1.jpg" alt="image desc" />
            </a>
          </figure>{/* End .entry-media */}
          <div className="entry-body text-center">
            <div className="entry-meta">
              <a href="#">Nov 22, 2018</a>, 1 Comments
            </div>{/* End .entry-meta */}
            <h3 className="entry-title">
              <a href="single.html">Sed adipiscing ornare.</a>
            </h3>{/* End .entry-title */}
            <div className="entry-content">
              <a href="single.html" className="read-more">Read More</a>
            </div>{/* End .entry-content */}
          </div>{/* End .entry-body */}
        </article>{/* End .entry */}
        <article className="entry">
          <figure className="entry-media">
            <a href="single.html">
              <img src="asset/images/demos/demo-7/blog/post-2.jpg" alt="image desc" />
            </a>
          </figure>{/* End .entry-media */}
          <div className="entry-body text-center">
            <div className="entry-meta">
              <a href="#">Dec 12, 2018</a>, 0 Comments
            </div>{/* End .entry-meta */}
            <h3 className="entry-title">
              <a href="single.html">Fusce lacinia arcuet nulla.</a>
            </h3>{/* End .entry-title */}
            <div className="entry-content">
              <a href="single.html" className="read-more">Read More</a>
            </div>{/* End .entry-content */}
          </div>{/* End .entry-body */}
        </article>{/* End .entry */}
        <article className="entry">
          <figure className="entry-media">
            <a href="single.html">
              <img src="asset/images/demos/demo-7/blog/post-3.jpg" alt="image desc" />
            </a>
          </figure>{/* End .entry-media */}
          <div className="entry-body text-center">
            <div className="entry-meta">
              <a href="#">Dec 19, 2018</a>, 2 Comments
            </div>{/* End .entry-meta */}
            <h3 className="entry-title">
              <a href="single.html">Quisque volutpat mattis eros.</a>
            </h3>{/* End .entry-title */}
            <div className="entry-content">
              <a href="single.html" className="read-more">Read More</a>
            </div>{/* End .entry-content */}
          </div>{/* End .entry-body */}
        </article>{/* End .entry */}
        <article className="entry">
          <figure className="entry-media">
            <a href="single.html">
              <img src="asset/images/demos/demo-7/blog/post-4.jpg" alt="image desc" />
            </a>
          </figure>{/* End .entry-media */}
          <div className="entry-body text-center">
            <div className="entry-meta">
              <a href="#">Dec 25, 2018</a>, 3 Comments
            </div>{/* End .entry-meta */}
            <h3 className="entry-title">
              <a href="single.html">Mauris suscipit in massa.</a>
            </h3>{/* End .entry-title */}
            <div className="entry-content">
              <a href="single.html" className="read-more">Read More</a>
            </div>{/* End .entry-content */}
          </div>{/* End .entry-body */}
        </article>{/* End .entry */}
      </div>{/* End .owl-carousel */}
    </div>{/* End .blog-posts */}
  </div>{/* End .container-fluid */}
  <div className="bg-light-2 pt-7 pb-6 testimonials">
    <div className="container">
      <h2 className="title text-center mb-2">Our Customers Say</h2>{/* End .title text-center */}
      <div className="owl-carousel owl-simple owl-testimonials" data-toggle="owl" data-owl-options="{
          &quot;nav&quot;: false, 
          &quot;dots&quot;: true,
          &quot;margin&quot;: 20,
          &quot;loop&quot;: false,
          &quot;responsive&quot;: {
              &quot;1200&quot;: {
                  &quot;nav&quot;: true
              }
          }
      }">
        <blockquote className="testimonial testimonial-icon text-center">
          <p className="lead">“Really great store”</p>{/* End .lead */}
          <p>“ Donec nec justo eget felis facilisis fermentum. Aliquam porttitor mauris sit amet orci. Aenean dignissim pellentesque felis. Morbi in sem quis dui placerat ornare. Pellentesque odio nisi, euismod in, pharetra<br />a, ultricies in, diam. Sed arcu. ”</p>
          <cite>
            Charly Smith,
            <span>Customer</span>
          </cite>
        </blockquote>{/* End .testimonial */}
        <blockquote className="testimonial testimonial-icon text-center">
          <p className="lead">“Friendly Support”</p>{/* End .lead */}
          <p>“ Impedit, ratione sequi, sunt incidunt magnam et. Delectus obcaecati optio eius error libero perferendis nesciunt atque dolores magni recusandae! Doloremque quidem error eum quis similique doloribus natus qui ut ipsum.”</p>
          <cite>
            Damon Stone
            <span>Customer</span>
          </cite>
        </blockquote>{/* End .testimonial */}
        <blockquote className="testimonial testimonial-icon text-center">
          <p className="lead">“Free Shipping”</p>{/* End .lead */}
          <p>“ Molestias animi illo natus ut quod neque ad accusamus praesentium fuga! Dolores odio alias sapiente odit delectus quasi, explicabo a, modi voluptatibus. Perferendis perspiciatis, voluptate, distinctio earum veritatis animi tempora eget blandit nunc tortor mollis ”</p>
          <cite>
            John Smith
            <span>Customer</span>
          </cite>
        </blockquote>{/* End .testimonial */}
      </div>{/* End .testimonials-slider owl-carousel */}
    </div>{/* End .container */}
  </div>{/* End .bg-light pt-5 pb-5 */}
  <div className="brands-border owl-carousel owl-simple" data-toggle="owl" data-owl-options="{
  &quot;nav&quot;: false, 
  &quot;dots&quot;: false,
  &quot;margin&quot;: 0,
  &quot;loop&quot;: false,
  &quot;responsive&quot;: {
      &quot;0&quot;: {
          &quot;items&quot;:2
      },
      &quot;420&quot;: {
          &quot;items&quot;:3
      },
      &quot;600&quot;: {
          &quot;items&quot;:4
      },
      &quot;900&quot;: {
          &quot;items&quot;:5
      },
      &quot;1024&quot;: {
          &quot;items&quot;:6
      },
      &quot;1360&quot;: {
          &quot;items&quot;:7
      }
  }
    }">
    <a href="#" className="brand">
      <img src="asset/images/brands/1.png" alt="Brand Name" />
    </a>
    <a href="#" className="brand">
      <img src="asset/images/brands/2.png" alt="Brand Name" />
    </a>
    <a href="#" className="brand">
      <img src="asset/images/brands/3.png" alt="Brand Name" />
    </a>
    <a href="#" className="brand">
      <img src="asset/images/brands/4.png" alt="Brand Name" />
    </a>
    <a href="#" className="brand">
      <img src="asset/images/brands/5.png" alt="Brand Name" />
    </a>
    <a href="#" className="brand">
      <img src="asset/images/brands/6.png" alt="Brand Name" />
    </a>
    <a href="#" className="brand">
      <img src="asset/images/brands/7.png" alt="Brand Name" />
    </a>
  </div>
</main>

        <UserFooter/>
    </div>
  )
}

export default Index7